export const getEmptySnapshot = (width: number, height: number) => {
  return {
    store: {
      'page:page': { id: 'page:page', meta: {}, name: 'Page 1', index: 'a1', typeName: 'page' },
      'document:document': { id: 'document:document', meta: {}, name: '', gridSize: 10, typeName: 'document' },
      'shape:PltNSAn0bgXuqMDRmMCfz': {
        x: 0,
        y: 0,
        id: 'shape:PltNSAn0bgXuqMDRmMCfz',
        meta: {},
        type: 'frame',
        index: 'a1',
        props: {
          h: height,
          w: width,
          fill: { type: 'solidColor', color: '#ffffff', opacity: 1 },
          name: '',
          caption: null,
          position: 1,
          isEditable: true,
          isAutoUpdatable: true,
        },
        opacity: 1,
        isLocked: false,
        parentId: 'page:page',
        rotation: 0,
        typeName: 'shape',
      },
    },
    schema: {
      storeVersion: 4,
      schemaVersion: 1,
      recordVersions: {
        page: { version: 1 },
        asset: { version: 1, subTypeKey: 'type', subTypeVersions: { image: 2, video: 2, bookmark: 0 } },
        shape: {
          version: 3,
          subTypeKey: 'type',
          subTypeVersions: { mask: 3, frame: 4, group: 0, image: 11, video: 3, textBox: 6, geometric: 7 },
        },
        camera: { version: 1 },
        pointer: { version: 1 },
        document: { version: 2 },
        instance: { version: 22 },
        instance_presence: { version: 5 },
        instance_page_state: { version: 5 },
      },
    },
  }
}
